<template>
  <v-dialog :value="true" max-width="1080" @input="handleVisibility">
    <v-card dark>
      <v-card-title>
        {{ trainer.fullName || "Trainer" }}
        <v-spacer />
        <v-btn icon aria-label="Historie schliessen" @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <trainer-workout-history :rows="rows" :loading="loading" :error="error" :range-label="rangeLabel" @refresh="loadHistory" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "../../../api"
import TrainerWorkoutHistory from "./TrainerWorkoutHistory.vue"

export default {
  name: "TrainerWorkoutHistoryDialog",
  components: { TrainerWorkoutHistory },
  props: {
    trainer: { type: Object, required: true },
    studios: { type: Array, default: () => [] },
    range: { type: Array, default: () => [] },
  },
  data() {
    return { rows: [], loading: false, error: "", requestSerial: 0 }
  },
  computed: {
    requestKey() {
      return JSON.stringify([this.trainer._id, this.studios.map((studio) => studio?._id || studio), this.range])
    },
    rangeLabel() {
      return this.range.map((date) => this.$moment(date).format("DD.MM.YYYY")).join(" – ")
    },
  },
  watch: {
    requestKey: { immediate: true, handler: "loadHistory" },
  },
  beforeDestroy() {
    this.requestSerial += 1
  },
  methods: {
    handleVisibility(visible) {
      if (!visible) this.$emit("close")
    },
    async loadHistory() {
      const requestId = ++this.requestSerial
      this.rows = []
      this.error = ""
      if (!this.trainer._id || !this.range[0] || !this.range[1]) {
        this.loading = false
        this.error = "Bitte einen Trainer und einen vollständigen Zeitraum auswählen."
        return
      }
      this.loading = true
      try {
        const result = await api.fetchTrainerDashboardInfoDetails({
          trainer: this.trainer._id,
          studios: this.studios.map((studio) => studio?._id || studio).filter(Boolean),
          range: this.range.map((date) => this.$moment(date).format("YYYY-MM-DD")),
        })
        if (requestId !== this.requestSerial) return
        this.rows = Array.isArray(result?.activities?.workouts) ? result.activities.workouts : []
      } catch (error) {
        if (requestId !== this.requestSerial) return
        this.error = error?.response?.data?.message || "Die Trainingsplan-Historie konnte nicht geladen werden."
      } finally {
        if (requestId === this.requestSerial) this.loading = false
      }
    },
  },
}
</script>
